export default function(event){let sourceEvent;for(;sourceEvent=event.sourceEvent;)event=sourceEvent;return event}